/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
export default class WeatherService extends Service {
    constructor(axios) {
        super(axios);
    }
    /** 현재 날씨 정보 조회 */
    getCurrentWeather = async (siteId) => {
        return await this.get(apiWrapper.weatherAPI(`/qcells-${siteId}/currentweatherdata`));
    };
}
